export class WagonPreannouncement {
    estimatedArrivalDate = null;
}
